import { isValidURL, hasAcceptedProtocol } from "util/URLUtils";
const isSafeReferenceUrl = (url) => !!url && isValidURL(url) && hasAcceptedProtocol(url);
export default isSafeReferenceUrl;
